module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "phone-viewport"
  }, [_c('section', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "col-half"
  }, [_c('md-input-container', [_c('label', [_vm._v("Number/编号")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.yourname),
      callback: function($$v) {
        _vm.yourname = $$v
      },
      expression: "yourname"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Contact/联系方式")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.contact),
      callback: function($$v) {
        _vm.contact = $$v
      },
      expression: "contact"
    }
  })], 1)], 1), _vm._v(" "), _c('md-input-container', [_c('md-switch', {
    model: {
      value: (_vm.realMode),
      callback: function($$v) {
        _vm.realMode = $$v
      },
      expression: "realMode"
    }
  }, [_vm._v(_vm._s(_vm.realMode ? 'Experiment' : 'Practice') + " Mode/" + _vm._s(_vm.realMode ? '实测' : '示例') + "模式")])], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Test Type/测试类型")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "type"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": _vm.TYPE_PIC
    }
  }, [_vm._v("Picture Naming/图片命名")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": _vm.TYPE_LEX
    }
  }, [_vm._v("Lexical Decision/词汇判断")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": _vm.TYPE_FLANKER
    }
  }, [_vm._v("Flanker/箭头测试")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": _vm.TYPE_SIMON
    }
  }, [_vm._v("Simon/西蒙测试")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": _vm.TYPE_IQ
    }
  }, [_vm._v("IQ Test/IQ测试")])], 1)], 1), _vm._v(" "), (_vm.type === 'lexical-decision') ? _c('md-input-container', [_c('label', [_vm._v("Languages/语言")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "type"
    },
    model: {
      value: (_vm.language),
      callback: function($$v) {
        _vm.language = $$v
      },
      expression: "language"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "chinese"
    }
  }, [_vm._v("Chiese/中文")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "uyghur"
    }
  }, [_vm._v("Uyghur/维文")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showError && !_vm.contact) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Please enter contact/请填写联系方式")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.start($event)
      }
    }
  }, [_vm._v("Start/开始")]), _vm._v(" "), (_vm.hasData && _vm.realMode) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.download($event)
      }
    }
  }, [_vm._v("Export/导出")]) : _vm._e(), _vm._v(" "), (_vm.realMode && _vm.hasData) ? _c('md-button', {
    staticClass: "md-raised md-warn",
    nativeOn: {
      "click": function($event) {
        _vm.upload($event)
      }
    }
  }, [_vm._v("Save/保存")]) : _vm._e()], 1), _vm._v(" "), _c('section', {
    ref: "container",
    class: ['container', {
      'processing': _vm.current >= 0
    }]
  }, [_vm._l((_vm.list), function(item, index) {
    return (_vm.current >= (index + 1)) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.current <= (index + 1)),
        expression: "current <= (index + 1)"
      }]
    }, [_c(_vm.type, {
      tag: "component",
      attrs: {
        "item": item,
        "language": _vm.language
      },
      on: {
        "end": _vm.next
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.current === 0) ? _c('div', {
    staticClass: "instruction"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "transparent",
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": _vm.play
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "instruction-content"
  }, [_c('p', {
    staticClass: "instruction-header"
  }, [_vm._v(_vm._s(_vm.instructionContent.header))]), _vm._v(" "), _c('p', {
    staticClass: "instruction-body",
    domProps: {
      "innerHTML": _vm._s(_vm.instructionContent[_vm.sumType])
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "instruction-footer"
  }, [_vm._v(_vm._s(_vm.instructionContent.footer))])])]) : _vm._e()], 2), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [(_vm.type === _vm.TYPE_PIC) ? _c('md-list', _vm._l((_vm.results[_vm.TYPE_PIC]), function(result, index) {
    return _c('md-list-item', {
      key: "index",
      attrs: {
        "href": _vm.blobUrl(result.record),
        "target": '_blank'
      }
    }, [_c('md-avatar', [_c('img', {
      attrs: {
        "src": result.src
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(result.name) + " - (" + _vm._s(result.response) + "ms)")]), _vm._v(" "), _c('span', [_vm._v("[" + _vm._s(result.language) + "]")])], 1)
  })) : _vm._e(), _vm._v(" "), _vm._l(([_vm.TYPE_LEX_CN, _vm.TYPE_LEX_UG]), function(typeLex, typeIdx) {
    return (_vm.type === _vm.TYPE_LEX) ? _c('md-list', {
      key: "typeIdx"
    }, _vm._l((_vm.results[typeLex]), function(result, index) {
      return (_vm.sumType === typeLex) ? _c('md-list-item', {
        key: "index"
      }, [_c('md-avatar', [_c('img', {
        attrs: {
          "src": result.src
        }
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(result.name) + " - (" + _vm._s(result.response) + "ms)")]), _vm._v(" "), _c('span', [_vm._v("[" + _vm._s(result.language) + "]")]), _vm._v(" "), _c('small', [_vm._v("Choice/选择(Fact/实际)：" + _vm._s(result.selection ? 'True/真' : 'False/假') + "(" + _vm._s(!result.isNon ? 'True/真' : 'False/假') + ")")]), _vm._v(" "), (result.selection !== result.isNon) ? _c('md-icon', {
        staticClass: "md-primary",
        attrs: {
          "md-theme": "green"
        }
      }, [_vm._v("∨")]) : _c('md-icon', {
        staticClass: "md-warn",
        attrs: {
          "md-theme": "orange"
        }
      }, [_vm._v("x")])], 1) : _vm._e()
    })) : _vm._e()
  }), _vm._v(" "), (_vm.type === _vm.TYPE_FLANKER) ? _c('md-list', _vm._l((_vm.results[_vm.sumType]), function(result, index) {
    return _c('md-list-item', {
      key: "index"
    }, [_c('span', [(result.type === 'con') ? [_vm._v("Congruent/一致")] : (result.type === 'incon') ? [_vm._v("Incongruent/不一致")] : (result.type === 'neu') ? [_vm._v("Neutral/中立")] : _vm._e()], 2), _vm._v(" "), _c('span', [_c('small', [_vm._v("Selection/选择: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(result.selection))]), _vm._v(" "), _c('small', [_vm._v(" - " + _vm._s(result.response) + "ms")]), _vm._v(" "), (result.selection === result.direction) ? _c('md-icon', {
      staticClass: "md-primary",
      attrs: {
        "md-theme": "green"
      }
    }, [_vm._v("∨")]) : _c('md-icon', {
      staticClass: "md-warn",
      attrs: {
        "md-theme": "orange"
      }
    }, [_vm._v("x")])], 1)])
  })) : _vm._e(), _vm._v(" "), (_vm.type === _vm.TYPE_SIMON) ? _c('md-list', _vm._l((_vm.results[_vm.sumType]), function(result, index) {
    return _c('md-list-item', {
      key: "index"
    }, [_c('md-avatar', {
      style: ({
        background: result.type === 'blue' ? '#0c83e8' : '#e80d0d'
      })
    }), _vm._v(" "), _c('span', [(result.type === 'blue') ? [_vm._v("Blue/蓝色")] : (result.type === 'red') ? [_vm._v("Red/红色")] : _vm._e(), _vm._v(" "), _c('small', [_vm._v("Position/位置: " + _vm._s(result.direction))])], 2), _vm._v(" "), _c('span', [_c('small', [_vm._v("Selection/选择: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(result.selection))]), _vm._v(" "), _c('small', [_vm._v(" - " + _vm._s(result.response) + "ms")]), _vm._v(" "), (result.selection === result.direction) ? _c('md-icon', {
      staticClass: "md-primary",
      attrs: {
        "md-theme": "green"
      }
    }, [_vm._v("∨")]) : _c('md-icon', {
      staticClass: "md-warn",
      attrs: {
        "md-theme": "orange"
      }
    }, [_vm._v("x")])], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.type === _vm.TYPE_IQ && _vm.IQscore) ? _c('div', {
    staticClass: "score"
  }, [_vm._v("Score/最后得分：" + _vm._s(_vm.IQscore) + "/60")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e297dbfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard.vue
// module id = 171
// module chunks = 1